import SidebarChevronActiveIcon from '@/assets/images/icons/sidebar-chevron-active.svg';
import React, { useState } from 'react';
import { Platform, Pressable, View } from 'react-native';

type Props = {
  expanded: boolean;
  onPress: () => void;
  accessibilityLabel: string;
};

export function LessonSidebarToggleButton({
  expanded,
  onPress,
  accessibilityLabel,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const chevronRotation = expanded ? '180deg' : '0deg';

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      onHoverIn={() => Platform.OS === 'web' && setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={({ pressed }) => [
        {
          height: 40,
          paddingHorizontal: 8,
          borderRadius: 8,
          borderWidth: 1,
          borderColor: '#C9C5C3',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: hovered || pressed ? '#F4F1ED' : '#FFF',
          flexShrink: 0,
          flexDirection: 'row',
          ...(Platform.OS === 'web' ? ({ cursor: 'pointer' } as const) : null),
        },
        Platform.OS === 'web'
          ? ({
              boxShadow:
                '0 2px 4px 0 rgba(0,0,0,0.12), 0 0 2px 0 rgba(0,0,0,0.08)',
            } as const)
          : ({
              shadowColor: '#000',
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.12,
              shadowRadius: 4,
              elevation: 2,
            } as const),
      ]}
    >
      <View style={{ transform: [{ rotate: chevronRotation }], flexDirection: 'row' }}>
        <SidebarChevronActiveIcon width={7} height={12} />
        <SidebarChevronActiveIcon width={7} height={12} style={{ marginLeft: -2 }} />
      </View>
    </Pressable>
  );
}
